"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleUpdateTRMVRMeterEntry = exports.handleCreateTRMVRMeterEntry = exports.fetchMeterentry = exports.updateEntryResponse = exports.createEntryResponse = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const t = require("io-ts");
const ActionTypes = require("../../actionTypes/trmvrmeterentries/current");
const Actions = require("../../actions/trmvrmeterentries/current");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
exports.createEntryResponse = t.interface({
    uuid: t.string
});
exports.updateEntryResponse = sok_types_1.TRMVRMeterEntry.iTRMVRMeterEntry;
function fetchMeterentry(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/trmvrmeter/${action.payload.meterUuid}/entry/${action.payload.entryUuid}`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return sok_types_1.TRMVRMeterEntry.iTRMVRMeterEntry
            .decode(xhr.response)
            .fold((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseValidationError)(error))), (trmvrmeterentries) => (0, rxjs_1.of)(Actions.fetchSuccess(trmvrmeterentries)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchMeterentry = fetchMeterentry;
function handleCreateTRMVRMeterEntry(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_ENTRY_REQUEST), (0, operators_1.mergeMap)((request) => {
        const meterUuid = request.payload.meterUuid;
        const body = {
            date: request.payload.meterDate,
            meter_type: request.payload.meterType
        };
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: body,
            url: `${baseUrl}api/trmvrmeter/${meterUuid}/entry`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            return exports.createEntryResponse
                .decode(xhr.response)
                .fold((error) => (0, rxjs_1.of)(Actions.createEntryFailed((0, errorHandling_1.parseValidationError)(error))), (meterentry) => (0, rxjs_1.of)(Actions.createEntrySuccess(meterentry)));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.createEntryFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleCreateTRMVRMeterEntry = handleCreateTRMVRMeterEntry;
function handleUpdateTRMVRMeterEntry(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPDATE_ENTRY_REQUEST), (0, operators_1.mergeMap)((request) => {
        const meterUuid = request.payload.meterUuid;
        const entryUuid = request.payload.entryUuid;
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PUT',
            body: request.payload.entry,
            url: `${baseUrl}api/trmvrmeter/${meterUuid}/entry/${entryUuid}`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            return exports.updateEntryResponse
                .decode(xhr.response)
                .fold((error) => (0, rxjs_1.of)(Actions.updateEntryFailed((0, errorHandling_1.parseValidationError)(error))), (meterentry) => (0, rxjs_1.of)(Actions.updateEntrySuccess(meterentry)));
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.updateEntryFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
    }));
}
exports.handleUpdateTRMVRMeterEntry = handleUpdateTRMVRMeterEntry;
//# sourceMappingURL=current.js.map